module.exports = __webpack_public_path__ + "static/media/icn_fundwise_summary.c8f7d4c9.svg";